import { render, staticRenderFns } from "./AlphaDiversityWidget.vue?vue&type=template&id=eee18b4c&scoped=true"
import script from "./AlphaDiversityWidget.vue?vue&type=script&lang=js"
export * from "./AlphaDiversityWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee18b4c",
  null
  
)

export default component.exports